import React from "react";
import { useParams } from "react-router-dom";
import Theme404 from "../../layout/404";

import event_list from "./event.list";
import event_edit from "./event.edit";

/**
 *   Create index file for Event
 */

export default function List_event() {
  let useParam = {} as any;
  useParam = useParams();
  let Param = useParam.slug || "list";

  let ActualPage: any;
  switch (Param) {
    case "list":
      ActualPage = event_list;
      break;

    case "edit":
      ActualPage = event_edit;
      break;

    case "new":
      ActualPage = event_edit;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

